import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'de'
  },
  mutations: {
    SET_LANGUAGE (state, value) {
      state.language = value
    }
  },
  getters: {
    language (state) {
      return state.language
    }
  },
  actions: {
  },
  modules: {
  }
})
